import { axiosInstance, axiosInstanceWithToken } from "@/utils/axios";
import { HOST_API_KEY } from "../../config";

export const updateAreaCluster = async (id, data) => {
  const request = await axiosInstanceWithToken.patch(
    `${HOST_API_KEY}/admin/area-clusters/${id}`,
    data
  );
  return request.data;
};

export const getAreaClustersInBounds = async (params = {}) => {
  const request = await axiosInstance.get(
    `${HOST_API_KEY}/places/area-clusters`,
    { params }
  );
  return request.data;
};

/**
 * 지도에 얹는 **작은 이름표**(홍대 놀이터·상상마당…).
 * 상권 칩과 달리 숫자도 없고 누르는 것도 아니다 — 여기가 어디인지 읽는 용도다.
 */
export const getAreaLandmarksInBounds = async (params = {}) => {
  const request = await axiosInstance.get(
    `${HOST_API_KEY}/places/area-landmarks`,
    { params }
  );
  return request.data;
};

export const createAreaCluster = async (data) => {
  const request = await axiosInstanceWithToken.post(
    `${HOST_API_KEY}/admin/area-clusters`,
    data
  );
  return request.data;
};

export const deleteAreaCluster = async (id) => {
  const request = await axiosInstanceWithToken.delete(
    `${HOST_API_KEY}/admin/area-clusters/${id}`
  );
  return request.data;
};

/** 큰 이름 — 넓게 볼 때 뜨는 이름(건대입구·신촌). 속한 세부도 같이 온다. */
export const getAreaGroups = async (params = {}) => {
  const request = await axiosInstanceWithToken.get(
    `${HOST_API_KEY}/admin/area-groups`,
    { params }
  );
  return request.data;
};

export const updateAreaGroup = async (id, data) => {
  const request = await axiosInstanceWithToken.patch(
    `${HOST_API_KEY}/admin/area-groups/${id}`,
    data
  );
  return request.data;
};

export const getAreaGroupsInBounds = async (params = {}) => {
  const request = await axiosInstance.get(
    `${HOST_API_KEY}/places/area-groups`,
    { params }
  );
  return request.data;
};

/**
 * 지역 사전에서 동네 찾기 — 지도에서 자리를 찍기 **전에** 그 동네로 옮겨 놓는 용도.
 *
 * 검색에 쓰는 사전(동 4,267 + 역)을 그대로 읽는다. 없으면 도봉면허시험장 하나 넣으려고
 * 서울시청에서 도봉까지 손으로 끌어야 한다.
 */
export const searchAreaGazetteer = async (q) => {
  const request = await axiosInstanceWithToken.get(
    `${HOST_API_KEY}/admin/area-gazetteer`,
    { params: { q } }
  );
  // ⚠️ axiosInstanceWithToken 은 4xx 도 '성공'으로 넘긴다(validateStatus). 배열인지 본다.
  return Array.isArray(request.data) ? request.data : [];
};
